import { usePortalProfileQuery } from "@dashboard/graphql";
import { Box, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { Page, Section } from "./components";
import { portalMessages as m } from "./messages";
import { ProfileForm } from "./ProfileForm";

/** First sign-in, after the documents: the colaborador fills in their own
 * contacts before using the portal. */
export const ProfileCompletion = ({ onDone }: { onDone: () => void }) => {
  const intl = useIntl();
  const { data } = usePortalProfileQuery({ fetchPolicy: "network-only" });
  const profile = data?.myEmployeeProfile;

  return (
    <Page>
      <Section title={intl.formatMessage(m.completeProfileTitle)}>
        <Text size={3} color="default2">
          {intl.formatMessage(m.completeProfileBody)}
        </Text>
        {profile && (
          <Box>
            <ProfileForm
              profile={profile}
              missingFields={profile.missingFields}
              submitLabel={m.continue}
              onSaved={onDone}
            />
          </Box>
        )}
      </Section>
    </Page>
  );
};
